import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, X } from 'lucide-react';
import { WIDGET_REGISTRY, sizeColClass } from './widgetRegistry';

const SortableWidget = ({ widget, data, customizing, onRemove }) => {
  const entry = WIDGET_REGISTRY[widget.id];
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: widget.id,
    disabled: !customizing,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 10 : 'auto',
  };

  if (!entry) return null;
  const Comp = entry.Component;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`relative ${sizeColClass(widget.size || entry.defaultSize)}`}
      data-testid={`sortable-widget-${widget.id}`}
    >
      {customizing && (
        <div className="absolute top-2 right-2 z-20 flex items-center gap-1">
          <button
            type="button"
            onClick={() => onRemove(widget.id)}
            className="p-1.5 bg-white border border-slate-300 rounded-sm hover:bg-red-50 hover:border-red-400 transition-colors"
            title="Remove widget"
            data-testid={`remove-widget-${widget.id}`}
          >
            <X size={14} className="text-slate-600 hover:text-red-600" />
          </button>
          <button
            type="button"
            {...attributes}
            {...listeners}
            className="p-1.5 bg-white border border-slate-300 rounded-sm hover:bg-slate-100 transition-colors cursor-grab active:cursor-grabbing"
            title="Drag to reorder"
            data-testid={`drag-widget-${widget.id}`}
          >
            <GripVertical size={14} className="text-slate-600" />
          </button>
        </div>
      )}
      {customizing && (
        <div className="absolute inset-0 z-10 bg-slate-900/0 border-2 border-dashed border-slate-300 rounded-sm pointer-events-none" />
      )}
      <Comp data={data} />
    </div>
  );
};

export default SortableWidget;
